<template>
  <div class="about-layout">
    <h1>About</h1>
    <p>
      Paper Boat is a journaling app designed to help you let your thoughts truly flow knowing that once you're done, they'll be gone. Pick a piece of art that resonates the most, and write whatever feels right in that moment. Your journal entry is not stored or sent anywhere. Once you click Set it Free, your entry is gone. Allow yourself to let go of what is no longer serving you.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
};
</script>

<style scoped>
.about-layout {
  max-width: 600px;
  margin: 40px auto;
  padding: 2em;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  text-align: center;
  font-family: 'Quicksand', 'Segoe UI', 'Roboto', sans-serif;
}
.about-layout h1 {
  font-size: 2.2rem;
  margin-bottom: 1em;
}
.about-layout p {
  font-size: 1.15rem;
  color: #444;
  margin-bottom: 1em;
}
.gobeyonddev-logo {
  margin-top: 0.5em;
  width: 300px;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.92;
}

@media (max-width: 600px) {
  .gobeyonddev-logo {
    width: 100%;
    max-width: 300px;
    min-width: 120px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  .about-layout {
    margin: 5px auto;
    padding: 1em 0.5em 1.5em 0.5em;
  }
  .about-layout h1 {
    margin-top: 0;
  }
}
</style>
